import { render, staticRenderFns } from "./DistributedTreemap.vue?vue&type=template&id=2fc31c4b&"
import script from "./DistributedTreemap.vue?vue&type=script&lang=js&"
export * from "./DistributedTreemap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports